import { render, staticRenderFns } from "./appointmentConformationPage.vue?vue&type=template&id=60d6e4ba&scoped=true"
import script from "./appointmentConformationPage.vue?vue&type=script&lang=js"
export * from "./appointmentConformationPage.vue?vue&type=script&lang=js"
import style0 from "./appointmentConformationPage.vue?vue&type=style&index=0&id=60d6e4ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d6e4ba",
  null
  
)

export default component.exports